import { z } from "zod";
import { cssOklchToCssHex } from "../../../lib/colors";

/**
 * @description `{ theme: { background: '99% 0.003 82.12' } }`
 */
export type ThemeColorsSerialized = z.infer<typeof themeColorsSerializedSchema>;

export const themeColorsSerializedSchema = z
	.object({
		theme: z
			.object({
				background: z.string().optional(),
			})
			.optional(),
		"theme-primary": z
			.object({
				DEFAULT: z.string().optional(),
				background: z.string().optional(),
			})
			.optional(),
		"theme-button": z
			.object({
				DEFAULT: z.string().optional(),
				background: z.string().optional(),
			})
			.optional(),
	})
	.optional();

export const themeColors = {
	theme: {
		background: { var: "--theme-background-color", label: "Website background color" },
	},
	"theme-primary": {
		DEFAULT: { var: "--theme-primary-color", label: "Primary text color" },
		background: { var: "--theme-primary-background-color", label: "Primary background color" },
	},
	"theme-button": {
		DEFAULT: { var: "--theme-button-color", label: "Button text color" },
		background: { var: "--theme-button-background-color", label: "Button background color" },
	},
};

export const themeColorsToCssVariables = (savedColors: ThemeColorsSerialized) => {
	if (!savedColors) {
		return "";
	}

	const cssVariables = Object.entries(themeColors).map(([nodeKey, node]) => {
		const savedNode = savedColors?.[nodeKey];
		if (!savedNode) {
			return "";
		}

		return Object.entries(node).map(([leafKey, leaf]) => {
			const savedLeaf = savedNode?.[leafKey];
			if (!savedLeaf) {
				return "";
			}

			return `${leaf.var}: ${cssOklchToCssHex(savedLeaf)};`;
		});
	});
	return cssVariables.flat().filter(Boolean).join("\n");
};

export const colorPalettes = {
	neutral: {
		palette: {
			theme: {
				background: "100% 0 0",
			},
			"theme-primary": {
				DEFAULT: "13.63% 0.0364 259.2",
				background: "97.02% 0 0",
			},
			"theme-button": {
				DEFAULT: "98.51% 0 0",
				background: "20.46% 0 0",
			},
		},
	},
	blue: {
		palette: {
			theme: {
				background: "94.54% 0.03272872070331167 229.79821313325996",
			},
			"theme-primary": {
				DEFAULT: "45% 0.08 250",
				background: "85% 0.06 250",
			},
			"theme-button": {
				DEFAULT: "85% 0.06 250",
				background: "30.35% 0.09592541265120082 253.77614103526997",
			},
		},
	},
} satisfies Record<string, { palette: ThemeColorsSerialized }>;
